<template>
  <tw-container>
    <main class="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div class="text-center">
        <img src="../../img/logo.svg" alt="404" class="w-64 mx-auto">
        <p class="text-base font-semibold text-blue-600">
          404
        </p>
        <h1 class="mt-4 tracking-tight text-gray-900 sm:text-5xl">
          Page not found
        </h1>
        <p class="mt-6 text-base leading-7 text-gray-600">
          Sorry, we couldn’t find the page you’re looking for.
        </p>
        <div class="mt-10 flex items-center justify-center gap-x-6">
          <tw-button variant="warning" :to="{name: 'Home'}" size="lg">
            Go back home
          </tw-button>
          <tw-button :to="{name: 'ContactPage'}" variant="link" size="lg">
            Contact support <span aria-hidden="true">&rarr;</span>
          </tw-button>
        </div>
      </div>
    </main>
  </tw-container>
</template>

<script>
import TwContainer from '@/components/generic/tw-container.vue'
import TwCard from '@/components/generic/tw-card.vue'
import TwButton from '@/components/generic/tw-button.vue'

export default {
  components: { TwButton, TwCard, TwContainer }

}
</script>
